import Vue from "vue";
import Router from "vue-router";
import pcLayout from "@/layout";
import layout from "@/layout";
import { requirePage } from "@/utils/router.js";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default new Router({
  routes: [
    /*{
      path: "/",
      component: layout,
      children: [
        {
          path: "/",
          component: resolve =>
            requirePage({ pc: "index", h5: "index" }, resolve),
          name: "index",
          dbSource: "index", // 数据来源
          meta: {
            title: "首页",
            roles: []
          }
        }
      ]
    },*/
    {
      path: "/",
      component: layout,
      children: [
        {
          path: "/",
          component: resolve =>
            requirePage({ pc: "about", h5: "about" }, resolve),
          name: "about",
          dbSource: "about", // 数据来源
          meta: {
            title: "关于",
            roles: []
          }
        }
      ]
    },
    {
      path: "/about",
      component: layout,
      children: [
        {
          path: "/about",
          component: resolve =>
            requirePage({ pc: "about", h5: "about" }, resolve),
          name: "about",
          dbSource: "about", // 数据来源
          meta: {
            title: "关于",
            roles: []
          }
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js